import { alpha } from '@mui/system';

import { COLOR_ACCENT } from '../colors.constants';

export const colorsLinearProgress = {
  colorsLinearProgressBackground: alpha(COLOR_ACCENT, 0.2),
  colorsLinearProgressFillBackground: COLOR_ACCENT,
};
